<template>
    <div class="modal fade " id="cadastrodetrechos" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
        style="z-index: 9998">
        <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered ">
            <div class="modal-content custom-background-blue-light modal-cadastro-trechos">
                <div class="modal-header modal-header-cadastro-trechos">
                    <div class="row d-flex align-items-center container-header-trecho">
                        <div class="col-8">
                            <div class="search-container-trecho">
                                <i class="fa fa-search"></i>
                                <input type="text" placeholder="Pesquisar" class="search-trecho  shadow-light"
                                    v-model="searchTable" v-on:keyup.enter="filtered" />
                            </div>
                        </div>
                        <div class="col-1">
                            <button type="button" id="text-responsive" class="btn-buscar-trecho shadow-light"
                                @click="filtered">
                                Buscar
                            </button>
                        </div>
                        <div class="col-3" style="text-align: initial;">
                            <button type="button" class="btn-header-trecho  shadow-light" data-dismiss="modal"
                                @click="showModalAdicionarEditarTrecho('save')">
                                Adicionar Trecho
                            </button>
                        </div>
                    </div>
                </div>
                <div class="modal-body modal-body-cadastro-trecho custom-background-blue-light d-flex align-items-center"
                    align="center">
                    <div class="w-100">
                        <hr class="line-green-cadastro-trecho">
                        <div class="container-table-cadastro-trecho" id="style-scroll-cadastro-trecho">
                            <table class="table table-cadastro-trechos text-center">
                                <thead class="thead-cadastro-trechos">
                                    <tr class="tr-thead-cadastro-trechos">
                                        <th class="th-thead-cadastro-trecho nomes-trechos" scope="col">Nome Trechos</th>
                                        <th class="th-thead-cadastro-trecho" scope="col">Ponto Inicial</th>
                                        <th class="th-thead-cadastro-trecho" scope="col">Ponto Final</th>
                                        <th class="th-thead-cadastro-trecho" scope="col">Comprimento KM</th>
                                        <th class="th-thead-cadastro-trecho" scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody class="tbody-cadastro-trecho">
                                    <tr v-for="dado in filteredRowns" :key="dado">
                                        <td class="nomes-trechos">{{ dado.nome }}</td>
                                        <td>{{ dado.ponto_inicial.nome }}</td>
                                        <td>{{ dado.ponto_final.nome }}</td>
                                        <td>{{ dado.media_comprimento }}Km</td>
                                        <td>
                                            <button type="button"
                                                class="btns-table-cadastro-trecho btn text-weight shadow-light"
                                                @click="showModalConfiguracaoDeTrecho(dado)">
                                                <svg width="12" height="14" viewBox="0 0 18 22" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M5.99902 0.617188H11.999V2.63281H5.99902V0.617188ZM16.0303 7.03906L17.4365 5.58594C17.2178 5.33594 16.9834 5.10156 16.7334 4.88281C16.5146 4.63281 16.2803 4.39844 16.0303 4.17969L14.624 5.63281C13.8428 5.00781 12.9678 4.52344 11.999 4.17969C11.0615 3.80469 10.0615 3.61719 8.99902 3.61719C7.74902 3.61719 6.57715 3.85156 5.4834 4.32031C4.4209 4.78906 3.46777 5.44531 2.62402 6.28906C1.81152 7.10156 1.1709 8.05469 0.702148 9.14844C0.233398 10.2422 -0.000976562 11.3984 -0.000976562 12.6172C-0.000976562 13.8672 0.233398 15.0391 0.702148 16.1328C1.1709 17.2266 1.81152 18.1797 2.62402 18.9922C3.46777 19.8047 4.4209 20.4453 5.4834 20.9141C6.57715 21.3828 7.74902 21.6172 8.99902 21.6172C10.249 21.6172 11.4053 21.3828 12.4678 20.9141C13.5615 20.4453 14.5146 19.8047 15.3271 18.9922C16.1709 18.1797 16.8271 17.2266 17.2959 16.1328C17.7646 15.0391 17.999 13.8672 17.999 12.6172C17.999 11.5547 17.8271 10.5547 17.4834 9.61719C17.1396 8.64844 16.6553 7.78906 16.0303 7.03906ZM9.9834 13.6484H8.01465V7.64844H9.9834V13.6484Z"
                                                        fill="#292994" />
                                                </svg>
                                            </button>
                                            <button type="button"
                                                class="btns-table-cadastro-trecho btn text-weight shadow-light"
                                                @click="showModalAdicionarEditarTrecho('edit', dado)">
                                                <svg width="13" height="13" viewBox="0 0 19 19" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M16.25 12.8203V4.61719C16.25 3.89844 16.0625 3.24219 15.6875 2.64844C15.3438 2.02344 14.875 1.53906 14.2812 1.19531C13.6875 0.820312 13.0156 0.632812 12.2656 0.632812C11.5156 0.632812 10.8438 0.820312 10.25 1.19531C9.65625 1.53906 9.17188 2.02344 8.79688 2.64844C8.45312 3.24219 8.28125 3.89844 8.28125 4.61719V14.6484C8.28125 15.1797 8.07812 15.6484 7.67188 16.0547C7.29688 16.4297 6.82812 16.6172 6.26562 16.6172C5.70312 16.6172 5.21875 16.4297 4.8125 16.0547C4.4375 15.6484 4.25 15.1797 4.25 14.6484V6.44531C4.84375 6.22656 5.32812 5.86719 5.70312 5.36719C6.07812 4.86719 6.26562 4.28906 6.26562 3.63281C6.26562 3.07031 6.125 2.57031 5.84375 2.13281C5.59375 1.66406 5.23438 1.30469 4.76562 1.05469C4.32812 0.773438 3.82812 0.632812 3.26562 0.632812C2.70312 0.632812 2.1875 0.773438 1.71875 1.05469C1.28125 1.30469 0.921875 1.66406 0.640625 2.13281C0.390625 2.57031 0.265625 3.07031 0.265625 3.63281C0.265625 4.28906 0.453125 4.86719 0.828125 5.36719C1.20312 5.86719 1.6875 6.22656 2.28125 6.44531V14.6484C2.28125 15.3672 2.45312 16.0391 2.79688 16.6641C3.17188 17.2578 3.65625 17.7422 4.25 18.1172C4.84375 18.4609 5.51562 18.6328 6.26562 18.6328C7.01562 18.6328 7.6875 18.4609 8.28125 18.1172C8.875 17.7422 9.34375 17.2578 9.6875 16.6641C10.0625 16.0391 10.25 15.3672 10.25 14.6484V4.61719C10.25 4.08594 10.4375 3.63281 10.8125 3.25781C11.2188 2.85156 11.7031 2.64844 12.2656 2.64844C12.8281 2.64844 13.2969 2.85156 13.6719 3.25781C14.0781 3.63281 14.2812 4.08594 14.2812 4.61719V12.8203C13.6875 13.0078 13.2031 13.3672 12.8281 13.8984C12.4531 14.3984 12.2656 14.9766 12.2656 15.6328C12.2656 16.1953 12.3906 16.7109 12.6406 17.1797C12.9219 17.6172 13.2812 17.9766 13.7188 18.2578C14.1875 18.5078 14.7031 18.6328 15.2656 18.6328C15.8281 18.6328 16.3281 18.5078 16.7656 18.2578C17.2344 17.9766 17.5938 17.6172 17.8438 17.1797C18.125 16.7109 18.2656 16.1953 18.2656 15.6328C18.2656 14.9766 18.0781 14.3984 17.7031 13.8984C17.3281 13.3984 16.8438 13.0391 16.25 12.8203Z"
                                                        fill="#292994" />
                                                </svg>

                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import '../../../../assets/css/operacoes/cadastro-de-trechos/cadastro-de-trechos.css';
import http from '../../../../services/http.js';
export default {
    name: 'filtroLinhas',
    data: () => {
        return {
            orgid: null,
            filteredRowns: [],
            searchTable: '',
            trechos: [],
        }
    },
    mounted() {
        this.emitter.on('cadastrodetrechos', (data) => {
            this.orgid = data;
            this.getListSections();
            $('#cadastrodetrechos').modal('show');
        })
        this.emitter.on('reloadTrecho', (data) => { this.getListSections(); })

    },
    methods: {
        filtered() {
            if (!this.searchTable) {
                this.filteredRowns = this.trechos
            }
            this.filteredRowns = this.trechos.filter(trecho => {
                return trecho.nome.toLowerCase().includes(this.searchTable.toLowerCase()) ||
                    trecho.ponto_inicial.nome.toLowerCase().includes(this.searchTable.toLowerCase()) ||
                    trecho.ponto_final.nome.toLowerCase().includes(this.searchTable.toLowerCase()) ||
                    trecho.media_comprimento.toLowerCase().includes(this.searchTable.toLowerCase())
            })
        },
        showModalAdicionarEditarTrecho(type, data) {
            this.emitter.emit('cadastroeedicaodetrechos', [this.orgid, type, data])
        },
        showModalConfiguracaoDeTrecho(data) {
            this.emitter.emit('configuracaodetrecho', [this.orgid, data])
        },
        getListSections() {
            http.get('trechos', { params: { orgid: this.orgid } })
                .then(res => {
                    this.trechos = res.data;
                    this.filteredRowns = this.trechos;
                }).catch(err => console.error(err));
        },
    }
}
</script>